const styles = theme => ({
  root: {
    marginTop: 24,
    marginLeft: 24,
    marginBottom: 24,
    textAlign: 'left',
    alignItems: 'left',
  },
  maxSpace: {
    position: 'relative',
    textAlign: 'left',
    marginLeft: 24,
    maxWidth: 150,
  },
  root2: {
    marginTop: 24,
    marginLeft: 24,
    marginBottom: 24,
    textAlign: 'center',
    alignItems: 'center',
  },
  textField: {
    marginLeft: 12,
    marginRight: 12,
    minWidth: 280,
  },
  seeall: {
    position: 'absolute',
    marginLeft: 65,
    marginTop: -52,
    [theme.breakpoints.up('sm')]: {
      marginLeft: 110,
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 110,
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/MultifolderView/components/User/components/Messages/styles.js